import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import logoPreta from '../../assets/roqt_data_ai_preto_transparente.png';
import logoBranca from '../../assets/roqt_data_ai_branco_transparente.png';
import './PoweredBy.css';

/**
 * Assinatura "Powered by ROQT" exibida ao final de todas as páginas.
 *
 * A logo tem duas versões de escrita (preta e branca), então a troca é feita
 * pelo arquivo — e não por filtro CSS — para manter os traços nítidos: tema
 * claro usa a preta, tema escuro usa a branca. O texto acompanha, em preto ou
 * branco puro.
 *
 * Fica montada uma única vez no layout (o <main> que envolve todas as rotas) e
 * outra na tela de login, cobrindo as páginas autenticadas e a não autenticada.
 * Como as abas das páginas são estado interno, a assinatura vale para todas elas.
 *
 * O conteúdo vai dentro de um container na camada 1 da escala de superfícies
 * (`--surface-layer-1`, translúcida) — o mesmo nível dos containers externos de
 * seção, como o card "Sobre os Dados".
 */
const PoweredBy = ({ className = '' }) => {
    const { isDark } = useTheme();

    return (
        <footer className={`powered-by ${className}`.trim()}>
            <div className="powered-by__card">
                <span className="powered-by__text">Powered by</span>
                <img
                    className="powered-by__logo"
                    src={isDark ? logoBranca : logoPreta}
                    alt="ROQT Data &amp; AI"
                />
            </div>
        </footer>
    );
};

export default PoweredBy;
